var map = {
	"./audio/9und3.ogg": "ff47",
	"./audio/mangel.ogg": "3d0d",
	"./audio/schlafmitmir.ogg": "ab70",
	"./images/andreaswiedenmann.jpeg": "f5f6",
	"./images/boluogulaorou.jpeg": "3d98",
	"./images/congyoubing.jpeg": "51ba",
	"./images/disanxian.jpeg": "a940"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";